import React from 'react';
import { Sparkles, BadgeDollarSign, Headset, ShieldCheck } from 'lucide-react';
import { whyUkiyo } from '../data/mock';
import { Card, CardContent } from './ui/card';
import WhatsAppCTA from './WhatsAppCTA';

const iconMap = {
  sparkles: Sparkles,
  'badge-dollar-sign': BadgeDollarSign,
  headset: Headset,
  'shield-check': ShieldCheck
};

const WhyUkiyo = () => {
  return (
    <section id="why-ukiyo" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-4 animate-fade-in-up">
            Why Travel With Ukiyo
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            Experience the difference of truly curated travel
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyUkiyo.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card 
                key={item.id}
                className="group border-none shadow-lg hover:shadow-2xl transition-all duration-500 bg-white hover:bg-gradient-to-br hover:from-white hover:to-gray-50 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="p-8 text-center">
                  <div className="w-16 h-16 bg-[#c9a961]/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#c9a961] transition-colors duration-300">
                    <IconComponent className="text-[#c9a961] group-hover:text-white transition-colors duration-300" size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-[#1e3a5f] mb-3">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <WhatsAppCTA message="Hi! I'd like to learn more about your curated travel services." />
      </div>
    </section>
  );
};

export default WhyUkiyo;
